$(document).ready(function() {
// window.isPincodeServiceable = false;
window.isPincodeServiceable = true;
  
    // pincode serviceability check - start
    // var validPincodes = [5001, 5002, 5003, 5004, 5005];
    var validPincodes = document.getElementById("localDeliveryGlobalValue").value.split(',').map(p => p.trim()); // array of strings like ["500063", "500041", ...]
  
    var pincodeCookieName = 'userPincode';

    function isPincodeValid(pincode) {
        return validPincodes.includes(pincode);
    }

    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function handlePincodeSubmit() {
        var allLineItems = document.querySelectorAll('.eligibility-check-line-item');
        var pincodeDivContainer = document.querySelector('#pincode-checker .pincodediv');
        var pincodeInput = document.getElementById('pincode');
        var pincodeMessage = document.getElementById('pincode-message');
        var checkoutButton = document.querySelector('button[name="checkout"]');
        var innerButton = pincodeDivContainer.querySelector('button');
        // var pincode = parseInt(pincodeInput.value.trim(), 10);
        var pincode = pincodeInput.value.trim();
        var isSixDigit = /^\d{6}$/.test(pincode);

        pincodeMessage.textContent = '';

        if (!isSixDigit) {
            pincodeMessage.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M18 6.5L12 12.5M12 12.5L6 18.5M12 12.5L18 18.5M12 12.5L6 6.5" stroke="#D8381C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Please enter a valid 6-digit pincode';
            pincodeMessage.style.color = '#D8381C';
            pincodeInput.style.background = '#FFB6A9';
            pincodeInput.style.color = '#D8381C';
            pincodeDivContainer.style.background = '#FFB6A9';
            pincodeDivContainer.style.border = '1px solid #D8381C';
            innerButton.style.borderLeft = '0.5px solid #D8381C';
          
            // ✅ Disable checkout button when pincode is invalid
            checkoutButton.disabled = true;
            window.isPincodeServiceable = false;
        
            return;
        }

        // if (!pincode) {
        //     pincodeMessage.textContent = 'Please enter a valid pincode';
        //     pincodeMessage.style.color = '#F05922';
        //     pincodeInput.style.background = '#FFF0E4';
        //     pincodeDivContainer.style.background = '#FFF0E4';
        //     pincodeDivContainer.style.border = '1px solid #F05922';
        //     return;
        // }

        // Store the pincode in a cookie
        setCookie(pincodeCookieName, pincode, 7);

        if (isPincodeValid(pincode)) {
            pincodeMessage.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 13.9993L8.5 17.4993L19 6.49927" stroke="#0F453D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>this product is available at your pincode!';
            pincodeMessage.style.color = '#0F453D';
            pincodeInput.style.background = '#E0E7AF';
            pincodeInput.style.color = '#0F453D';
            pincodeDivContainer.style.background = '#E0E7AF';
            pincodeDivContainer.style.border = '1px solid #0F453D';
            innerButton.style.borderLeft = '0.5px solid #0F453D';
            checkoutButton.disabled = false;
            window.isPincodeServiceable = true;

            allLineItems.forEach(element => {
              element.style.border = 'unset';

              const children = element.querySelector('.eligibility-check-msg');
              children.style.display = 'none';

              const achildren = element.querySelector('line-item-quantity span a.link');
              achildren.style.color = '#a36358';
            });
        } else {
            pincodeMessage.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M18 6.5L12 12.5M12 12.5L6 18.5M12 12.5L18 18.5M12 12.5L6 6.5" stroke="#D8381C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>A few products are not available for Delivery to your location. Kindly remove the product & try again.';
            pincodeMessage.style.color = '#D8381C';
            pincodeInput.style.background = '#FFB6A9';
            pincodeInput.style.color = '#D8381C';
            pincodeDivContainer.style.background = '#FFB6A9';
            pincodeDivContainer.style.border = '1px solid #D8381C';
            innerButton.style.borderLeft = '0.5px solid #D8381C';
            checkoutButton.disabled = true;
            window.isPincodeServiceable = false;

            allLineItems.forEach(element => {
              element.style.border = '1px solid #D8381C';

              const children = element.querySelector('.eligibility-check-msg');
              children.style.display = 'block';

              const achildren = element.querySelector('line-item-quantity span a.link');
              achildren.style.color = '#D8381C';
            });
        }
    }

    window.pincodeServiceability = function() {
        var pincodeDiv = document.getElementById('pincode-checker');
        var checkoutButton = document.querySelector('button[name="checkout"]');
        if (!checkoutButton) return; // Exit if the checkout button is not found

        checkoutButton.disabled = true;
        var lineItems = document.querySelectorAll('.line-item');
        var hasLocalDelivery = false;

        lineItems.forEach(function(lineItem) {
            var localDeliveryInput = lineItem.querySelector('input[name="localDeliveryValue"]');
            if (localDeliveryInput && localDeliveryInput.value === 'true') {
                hasLocalDelivery = true;
            }
        });

        if (hasLocalDelivery) {
            pincodeDiv.style.display = 'grid';
            var savedPincode = getCookie(pincodeCookieName);
            if (savedPincode) {
                var allLineItems = document.querySelectorAll('.eligibility-check-line-item');
                var pincodeDivContainer = document.querySelector('#pincode-checker .pincodediv');
                var pincodeMessage = document.getElementById('pincode-message');
                var innerButton = pincodeDivContainer.querySelector('button');
                // var pincode = parseInt(savedPincode, 10);
                var pincode = savedPincode.trim();
                var pincodeInput = document.getElementById('pincode');
                pincodeInput.value = pincode;

                

                if (isPincodeValid(pincode)) {
                    pincodeMessage.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 13.9993L8.5 17.4993L19 6.49927" stroke="#0F453D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>this product is available at your pincode!';
                    pincodeMessage.style.color = '#0F453D';
                    pincodeInput.style.background = '#E0E7AF';
                    pincodeInput.style.color = '#0F453D';
                    pincodeDivContainer.style.background = '#E0E7AF';
                    pincodeDivContainer.style.border = '1px solid #0F453D';
                    innerButton.style.borderLeft = '0.5px solid #0F453D';
                    checkoutButton.disabled = false;

                } else {
                    pincodeMessage.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 25" fill="none"><path d="M18 6.5L12 12.5M12 12.5L6 18.5M12 12.5L18 18.5M12 12.5L6 6.5" stroke="#D8381C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>A few products are not available for Delivery to your location. Kindly remove the product & try again.';
                    pincodeMessage.style.color = '#D8381C';
                    pincodeInput.style.background = '#FFB6A9';
                    pincodeInput.style.color = '#D8381C';
                    pincodeDivContainer.style.background = '#FFB6A9';
                    pincodeDivContainer.style.border = '1px solid #D8381C';
                    innerButton.style.borderLeft = '0.5px solid #D8381C';
                    checkoutButton.disabled = true;

                    allLineItems.forEach(element => {
                      element.style.border = '1px solid #D8381C';
        
                      const children = element.querySelector('.eligibility-check-msg');
                      children.style.display = 'block';
        
                      const achildren = element.querySelector('line-item-quantity span a.link');
                      achildren.style.color = '#D8381C';
                    });
                }
            }
        } else {
            checkoutButton.disabled = false;
        }

        // Reattach event listener for pincode submit button
        var pincodeSubmitButton = document.getElementById('pincode-submit');
        if (pincodeSubmitButton) {
            pincodeSubmitButton.removeEventListener('click', handlePincodeSubmit); // Remove any existing event listener
            pincodeSubmitButton.addEventListener('click', handlePincodeSubmit); // Attach the event listener
        }
    }

    // Initial pincode serviceability check
    pincodeServiceability();

    // Attach event listener for cart changes
    document.addEventListener("cart:change", function() {
        setTimeout(function() {
            pincodeServiceability();
        }, 300);
    });

    // Set blank pincode cookie on first visit if it doesn't exist
    if (!getCookie(pincodeCookieName)) {
        setCookie(pincodeCookieName, "", 7);
    }

    // pincode serviceability check - end
});


$(document).ready(function(){

  // adjusting values from - and + icons of cart
  
  // inititate main quantity changer
  attachCartEvents();

  // attach event listner for the cart change
  document.addEventListener("cart:change", function(){
     
      //console.log('kevin');
      
      setTimeout(function(){
          attachCartEvents();
      }, 2000);
  }); 

  // update cart items
  function updateCartItem( variant_id, quantity, operation){
      
      //co
      var data = { updates: {} };
      var item_count;
      //var data = [{ quantity: quantity, id: variant_id }];
      data.updates[variant_id] = quantity;
      
      $(".loading_wait").show();
      $(".loading_overlay").show();

      jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(result) { 
             
              $.when( 
                  jQuery.getJSON('/cart.js', function(cart) {
                      
                      item_count = cart.item_count;
                      let cartData = cart.items;
                      document.dispatchEvent(new CustomEvent('cart:build' ,{
                              bubbles: true
                          }
                      )); 
                      document.dispatchEvent(new CustomEvent('cart:refresh', {
                          bubbles: true,
                          detail: cartData
                      })); 
                  })
              ).then(function(){
                  
                  setTimeout(function(){
                      
                      // don't re-attach
                      if( window.location.pathname.indexOf('/cart/') == -1)
                          attachCartEvents();

                      $(".header__cart-count").find(".count-bubble").html(item_count);
                      $(".loading_wait").hide();
                      $(".loading_overlay").hide();
                      
                      // console.log('re-attached');
                  }, 2000);

              });
          }
      });
  }



  function justRefresh(){
      
    var data = { updates: {} };
    var item_count;
    
    $(".loading_wait").show();
    $(".loading_overlay").show();
  
    jQuery.ajax({
        type: 'GET',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function(result) { 
           
            $.when( 
                jQuery.getJSON('/cart.js', function(cart) {
                    
                    item_count = cart.item_count;
                    let cartData = cart.items;
                    document.dispatchEvent(new CustomEvent('cart:build' ,{
                            bubbles: true
                        }
                    )); 
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                        bubbles: true,
                        detail: cartData
                    })); 
                })
            ).then(function(){
                
                setTimeout(function(){
                    
                    // don't re-attach
                    if( window.location.pathname.indexOf('/cart/') == -1)
                        attachCartEvents();
  
                    $(".loading_wait").hide();
                    $(".loading_overlay").hide();
                    
                    // console.log('re-attached');
                }, 2000);
  
            });
  
            // console.log(result);
        }
    });
  }

  // main function for event attaching event listners
  function attachCartEvents(){
      $(".i_minus_cart").click(function(){
          //console.log("MINUS");
          
          var minus;
          
          let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');

          minus = parseInt( $inputBox.attr('value') ) - 1;
          
          $inputBox.attr('value', minus);
          
          //console.log($inputBox.attr('value'));
          //console.log(minus);
          //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', minus);
  
          var variant_id = $(this).parents('.line_changer').attr("line_var_id");
        
          updateCartItem(variant_id, minus, 'minus'); 
  
      });
      
      $(".i_plus_cart").click(function(){
          //console.log('PLUS')
          
          var plus, max, currrent_qty;
          let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');
          
          currrent_qty = parseInt( $inputBox.attr('value') );
          plus = currrent_qty + 1;
              
          $inputBox.attr('value', plus);

          //console.log(currrent_qty);
          //console.log(plus);
          //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', plus);

          var variant_id = $(this).parents('.line_changer').attr("line_var_id");
          updateCartItem(variant_id, plus, 'plus'); 
  
      });
    
      $("#nector-useyourcoins-container").click(function(){
          // justRefresh(); 
      });
    
  }
  
});


// footerjs
function initFlickeringWords() {
  const changeTextEl = document.getElementById("change-text");
  if (!changeTextEl) return;

  const words = changeTextEl.dataset.words.split(",").map(w => w.trim()).filter(w => w);
  if (words.length === 0) return;

  let currentIndex = 0;
  changeTextEl.textContent = words[currentIndex];

  setInterval(() => {
    changeTextEl.classList.add('fade-out');

    setTimeout(() => {
      currentIndex = (currentIndex + 1) % words.length;
      changeTextEl.textContent = words[currentIndex];
      changeTextEl.classList.remove('fade-out');
    }, 300);
  }, 3000);
}

// Run after page is loaded
document.addEventListener("DOMContentLoaded", function () {
  initFlickeringWords();
});

// OPTIONAL: If you're using theme sections that dynamically load (like via Ajax), listen to Shopify section load event
document.addEventListener("shopify:section:load", function () {
  initFlickeringWords();
});

(function () {
  function toggleShiprocketButton() {
    const srBtn = document.querySelector(
      '.shiprocket-headless button.sr-headless-checkout'
    );
    if (!srBtn) return;

    const pincodeCheckerExists =
      document.querySelector('#pincode-checker') &&
      document.querySelector('#pincode-checker').offsetParent !== null;

    // CASE 1: No pincode checker → always enabled
    if (!pincodeCheckerExists) {
      srBtn.disabled = false;
      srBtn.style.opacity = '1';
      srBtn.style.pointerEvents = 'auto';
      return;
    }

    // CASE 2: Pincode checker exists → validate
    if (window.isPincodeServiceable === true) {
      srBtn.disabled = false;
      srBtn.style.opacity = '1';
      srBtn.style.pointerEvents = 'auto';
    } else {
      srBtn.disabled = true;
      srBtn.style.opacity = '0.5';
      srBtn.style.pointerEvents = 'none';
    }
  }

  const observer = new MutationObserver(toggleShiprocketButton);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', toggleShiprocketButton);
  document.addEventListener('click', toggleShiprocketButton);
})();









